<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M11.37 5.63a1.01 1.01 0 00-1.429 0L5.63 9.952a1.014 1.014 0 000 1.432l4.312 4.321a1.01 1.01 0 001.43 0 1.014 1.014 0 000-1.432l-2.6-2.605h16.895a1 1 0 100-2H8.771l2.6-2.604a1.014 1.014 0 000-1.432zm9.259 10.667a1.01 1.01 0 011.43 0l4.311 4.32a1.014 1.014 0 010 1.433l-4.312 4.32a1.01 1.01 0 01-1.429 0 1.014 1.014 0 010-1.431l2.6-2.605H6.332a1 1 0 110-2h16.895l-2.599-2.605a1.014 1.014 0 010-1.432z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'arrowsLeftAndRightOutline'
}
</script>
